import {
  LayoutDashboard,
  Search,
  Target,
  Bell,
  Users,
  Key,
  Settings,
} from 'lucide-react';
import type { ComponentType, CSSProperties, SVGAttributes } from 'react';
import type { SubscriptionTier } from '../../types/subscription';

export interface NavItemDef {
  label: string;
  path: string;
  icon: ComponentType<SVGAttributes<SVGSVGElement>>;
  requiresTier?: SubscriptionTier;
}

export const NAV_ITEMS: NavItemDef[] = [
  { label: 'Dashboard', path: '/dashboard', icon: LayoutDashboard },
  { label: 'Scans', path: '/scans', icon: Search },
  { label: 'Competitors', path: '/competitors', icon: Target, requiresTier: 'pro' },
  { label: 'Monitoring', path: '/monitoring', icon: Bell, requiresTier: 'pro' },
  { label: 'Team', path: '/team', icon: Users, requiresTier: 'team' },
  { label: 'API Keys', path: '/api-keys', icon: Key, requiresTier: 'team' },
  { label: 'Settings', path: '/settings', icon: Settings },
];

export function shouldShowProBadge(
  requiresTier: SubscriptionTier | undefined,
  currentTier: SubscriptionTier,
): boolean {
  if (!requiresTier) return false;
  const tierOrder: SubscriptionTier[] = ['free', 'pro', 'team'];
  const requiredIndex = tierOrder.indexOf(requiresTier);
  const currentIndex = tierOrder.indexOf(currentTier);
  return currentIndex < requiredIndex;
}

export const PRO_BADGE_STYLE: CSSProperties = {
  marginLeft: 'auto',
  borderRadius: 9999,
  backgroundColor: 'rgba(99,102,241,0.2)',
  padding: '2px 8px',
  fontSize: 10,
  fontWeight: 600,
  color: '#6366f1',
  lineHeight: '16px',
};

export const TIER_BADGE_CONFIG: Record<SubscriptionTier, { label: string; bg: string; color: string }> = {
  free: { label: 'Free', bg: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.7)' },
  pro: { label: 'Pro', bg: 'rgba(99,102,241,0.2)', color: '#6366f1' },
  team: { label: 'Team', bg: 'rgba(16,185,129,0.2)', color: '#34d399' },
};
